import { ReportContext } from '@/app/providers/reportProvider';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card';
import { RadioGroupItem } from '@/components/ui/radio-group';
import { HoverCardArrow } from '@radix-ui/react-hover-card';
import { useContext } from 'react';
import { FaDollarSign } from 'react-icons/fa';

export function PriceCard({ price, title, tooltipContent, id, fullReport }) {
  let crossedPrice = '';
  const report = useContext(ReportContext);
  switch (price) {
    case report.Price_SUL:
      crossedPrice = '4,500';
      break;
    case report.Price_Multi:
      crossedPrice = '7,000';
      break;
    case report.Price_CUL:
      crossedPrice = '10,000';
      break;
  }

  return (
    <HoverCard openDelay={0} closeDelay={0}>
      <HoverCardContent
        className="w-40 bg-slate-700 invisible lg:visible"
        side="top"
        sideOffset={10}
      >
        <div className="space-x-4">
          <div className="space-y-1">
            <p className="text-sm text-white">{tooltipContent}</p>
          </div>
        </div>
        <HoverCardArrow className="fill-black" />
      </HoverCardContent>
      <HoverCardTrigger asChild>
        <div className="flex flex-col gap-y-1 items-center justify-center">
          <div className={id === 'r2' ? 'w-24' : ''}>
            {title}
            <br />
            {price === '2,200' ? (
              ''
            ) : (
              <div className="text-xs font-light">
                <span>({fullReport})</span>
                <h4 className="text-red-600 line-through">
                  US$ {crossedPrice}
                </h4>
              </div>
            )}
          </div>
          <p
            className={`items-center ${
              id === 'r2' && title != 'Excel Databook' ? 'mt-2' : ''
            }`}
          >
            US
            <FaDollarSign className="inline -mt-1" />
            <span>{price.toLocaleString()}</span>
          </p>
          <div>
            <RadioGroupItem value={price} id={id} className={'mb-1'} />
          </div>
        </div>
      </HoverCardTrigger>
    </HoverCard>
  );
}
